import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 22 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.375, d: "M11 19.024 2.211 9.857A5.2 5.2 0 0 1 7.485 1.23a5.2 5.2 0 0 1 2.08 1.272L11 3.936 12.436 2.5a5.2 5.2 0 0 1 7.354 7.353L11 19.024z" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
